import React from "react";
import { AlertTriangle, CheckCircle2, XCircle } from "lucide-react";
import { formatResultOption, resultOptionsMatch } from "../utils/resultPresentation";
import "./McqResultSummary.css";

const McqResultRow = ({ kind, title, option, fallback, status }) => (
  <div className={`mcq-result-row mcq-result-row--${kind}`}>
    <span className="mcq-result-letter" aria-hidden="true">{option?.label || "—"}</span>
    <span className="mcq-result-copy">
      <small>{title}</small>
      <strong>{formatResultOption(option, fallback)}</strong>
    </span>
    <span className="mcq-result-status">
      {kind === "correct" ? <CheckCircle2 size={15} /> : kind === "incorrect" ? <XCircle size={15} /> : null}
      {status}
    </span>
  </div>
);

const McqResultSummary = ({ mcqResult, showCorrect = true, studentLabel = "Your answer" }) => {
  const selected = mcqResult?.selectedOption || null;
  const correct = mcqResult?.correctOption || null;
  const selectionIsCorrect = resultOptionsMatch(selected, correct);
  const selectedKind = correct && !selectionIsCorrect ? "incorrect" : selectionIsCorrect ? "correct" : "selected";
  const selectedFallback = mcqResult?.selectedAnswerUnavailable
    ? "Submitted answer unavailable"
    : "No answer provided";

  return (
    <div className="mcq-result-summary">
      <McqResultRow
        kind={selectedKind}
        title={studentLabel}
        option={selected}
        fallback={selectedFallback}
        status={selectionIsCorrect ? "Correct" : studentLabel}
      />
      {showCorrect && correct && (
        <McqResultRow
          kind="correct"
          title="Correct answer"
          option={correct}
          fallback="Correct answer unavailable"
          status="Correct answer"
        />
      )}
      {showCorrect && !correct && mcqResult?.reviewRequired && (
        <div className="mcq-result-review" role="status">
          <AlertTriangle size={15} />
          <span><strong>Review required</strong> The authoritative answer is unavailable.</span>
        </div>
      )}
      {mcqResult?.reviewRequired && correct && (
        <div className="mcq-result-review" role="status">
          <AlertTriangle size={15} />
          <span><strong>Review required</strong> This question needs teacher attention.</span>
        </div>
      )}
    </div>
  );
};

export default McqResultSummary;
